export const posterColors = {
  gold: "#d6b96f",
  cream: "#f2ecdb",
  muted: "#c6c5b5",
  blue: "#9cc8e8",
  dark: "#081712",
};
export const posterSerif = '"Playfair Display", Georgia, serif';
export const posterSans = "Inter, system-ui, sans-serif";
export function textLine(
  ctx: CanvasRenderingContext2D,
  text: string,
  x: number,
  y: number,
  width: number,
  size: number,
  color = posterColors.cream,
  align: CanvasTextAlign = "left",
  serif = true,
) {
  ctx.textAlign = align;
  ctx.fillStyle = color;
  ctx.font = `400 ${size}px ${serif ? posterSerif : posterSans}`;
  ctx.fillText(text, x, y, width);
}
export function textLines(
  ctx: CanvasRenderingContext2D,
  text: string,
  x: number,
  y: number,
  width: number,
  size: number,
  maxLines = 2,
  color = posterColors.muted,
) {
  ctx.font = `400 ${size}px ${posterSans}`;
  const lines: string[] = [];
  let line = "";
  for (const word of text.split(/\s+/u)) {
    const next = line ? `${line} ${word}` : word;
    if (line && ctx.measureText(next).width > width) {
      lines.push(line);
      line = word;
    } else line = next;
  }
  if (line) lines.push(line);
  const shown = lines.slice(0, maxLines);
  if (lines.length > maxLines) shown[maxLines - 1] += "…";
  shown.forEach((value, i) =>
    textLine(
      ctx,
      value,
      x,
      y + i * size * 1.35,
      width,
      size,
      color,
      "left",
      false,
    ),
  );
}
export async function avatarImage(
  url: string | null,
): Promise<HTMLImageElement | null> {
  if (
    !url ||
    new URL(url, window.location.origin).origin !== window.location.origin
  )
    return null;
  return new Promise((resolve) => {
    const img = new Image();
    const timer = setTimeout(() => {
      img.src = "";
      resolve(null);
    }, 4000);
    img.onload = () => {
      clearTimeout(timer);
      resolve(img);
    };
    img.onerror = () => {
      clearTimeout(timer);
      resolve(null);
    };
    img.src = url;
  });
}
export function avatarCircle(
  ctx: CanvasRenderingContext2D,
  image: HTMLImageElement | null,
  name: string,
  x: number,
  y: number,
  size: number,
) {
  ctx.save();
  ctx.beginPath();
  ctx.arc(x + size / 2, y + size / 2, size / 2, 0, Math.PI * 2);
  ctx.clip();
  ctx.fillStyle = "#18392d";
  ctx.fillRect(x, y, size, size);
  if (image) ctx.drawImage(image, x, y, size, size);
  else
    textLine(
      ctx,
      name
        .split(/\s+/u)
        .map((w) => w[0])
        .slice(0, 2)
        .join("")
        .toUpperCase(),
      x + size / 2,
      y + size * 0.65,
      size * 0.8,
      size * 0.36,
      posterColors.gold,
      "center",
      false,
    );
  ctx.restore();
}
